import { BasicsClass } from '@/common/BasicsClass';

export default class PracticeBallSettingAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getList', {
      url: '/admin/practice/lists',
      name: 'lists',
      label: '列表'
    }],
    ['add', {
      url: '/admin/practice/add',
      name: 'add',
      label: '添加练球设置'
    }],
    ['update', {
      url: '/admin/practice/update',
      name: 'update',
      label: '修改练球设置'
    }],
    ['delete', {
      url: '/admin/practice/delete',
      name: 'delete',
      label: '删除练球设置'
    }],
    ['view', {
      url: '/admin/practice/view',
      name: 'view',
      label: '练球设置详情'
    }],
   
  ])


  public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


  public add(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('add').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


  public update(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('update').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


  public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('delete').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  public view(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('view').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  
}